import { StoreOrderListResponse, StoreOrderPendingCountResponse, StoreOrderResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/storefront-orders` — o pedido da loja online, para a vendedora
 * aprovar ou recusar (F224).
 */
export const fetchStoreOrders = async (query, signal) => StoreOrderListResponse.parse(await request(`/api/v1/storefront-orders?state=${query.state}${query.mine ? '&mine=true' : ''}`, { signal }));
export const fetchStoreOrderPendingCount = async (signal) => StoreOrderPendingCountResponse.parse(await request('/api/v1/storefront-orders/pending-count', { signal }));
export const approveStoreOrder = async (id, body) => StoreOrderResponse.parse(await request(`/api/v1/storefront-orders/${id}/approve`, {
    method: 'POST',
    body,
}));
export const rejectStoreOrder = async (id, body) => StoreOrderResponse.parse(await request(`/api/v1/storefront-orders/${id}/reject`, {
    method: 'POST',
    body,
}));
//# sourceMappingURL=storefront-orders.js.map